/**
 * Formats a number with commas for better readability
 * @param num - The number to format
 * @returns The formatted number string with commas
 *
 * @example
 * formatNumberWithCommas(298200) // "298,200"
 * formatNumberWithCommas(1234567) // "1,234,567"
 * formatNumberWithCommas(1000) // "1,000"
 */
export const formatNumberWithCommas = (num: number): string => {
  return num.toLocaleString();
};

/**
 * Formats a number with K and M suffixes for compact display
 * @param num - The number to format
 * @returns The formatted number string with appropriate suffix
 *
 * @example
 * formatCompactNumber(1400) // "1.4k"
 * formatCompactNumber(1000) // "1k"
 * formatCompactNumber(1200000) // "1.2mil"
 * formatCompactNumber(300) // "300"
 */
export const formatCompactNumber = (num: number): string => {
  if (num < 1000) {
    return num.toString();
  }

  if (num < 1000000) {
    const thousands = num / 1000;
    return thousands % 1 === 0 ? `${thousands}k` : `${thousands.toFixed(1)}k`;
  }

  const millions = num / 1000000;
  return millions % 1 === 0 ? `${millions}mil` : `${millions.toFixed(1)}mil`;
};
